import { ChangeDetectionStrategy, Component, Input, OnDestroy, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import {
  DataContextBuilder,
  ElderQuantityPipe,
  ElderTableComponent,
  IDataContext,
  Sort,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkBatch } from '../work-batch'
import {
  IWorkBatchDialogOptions,
  WorkBatchDetailDialogComponent,
} from '../work-batch-detail-dialog/work-batch-detail-dialog.component'
import { WorkBatchLineComponent } from '../work-batch-line/work-batch-line.component'
import { WorkBatchFilter, WorkBatchService } from '../work-batch.service'

@Component({
  selector: 'app-work-batch-browser',
  templateUrl: './work-batch-browser.component.html',
  styleUrls: ['./work-batch-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    WorkBatchLineComponent,
    ElderTranslatePipe,
    ElderQuantityPipe,
  ],
})
export class WorkBatchBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<WorkBatch>
  private workBatchService = inject(WorkBatchService)
  private dialog = inject(MatDialog)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<WorkBatch>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartOnFiltersAll([WorkBatchFilter.WORK_ORDER_KEY], [new Sort('createdAt', 'desc')])
      .build(this.workBatchService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set workOrder(workOrderId: string) {
    if (workOrderId) {
      const workOrderFilter = WorkBatchFilter.workOrderId(workOrderId)
      this.data.filter.updateFilter(workOrderFilter)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(batch: WorkBatch): void {
    if (batch) {
      this.dialog
        .open(WorkBatchDetailDialogComponent, {
          minWidth: '95vw',
          height: '95vh',
          data: <IWorkBatchDialogOptions>{
            batch: batch,
          },
        })
        .afterClosed()
        .subscribe((_) => this.data.reload())
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
